// SILKhee Palette Bar + Preview Modal
// State: localStorage key silkhee_palette = { size: 6, colors: [{name,code,hex,handle}] }
(function () {
'use strict';

if (window.location.pathname.startsWith('/checkout')) return;

const LS_KEY    = 'silkhee_palette';
const BAR_HEIGHT = 120;
const BUNDLE_VARIANTS = { 6: 43929475907627, 12: 43929569591339, 24: 43929578602539 };
const PACK_PRICES = { 6: '$36.18', 12: '$79.20', 24: '$156.00' };

function loadState() {
  try { return JSON.parse(localStorage.getItem(LS_KEY)) || { size: 6, colors: [] }; }
  catch(_) { return { size: 6, colors: [] }; }
}
function saveState(s) { localStorage.setItem(LS_KEY, JSON.stringify(s)); }

let state = loadState();
let previewOpenedAt = 0;

// ── DOM ────────────────────────────────────────────────────────
const bar        = document.getElementById('palette-bar');
const swatchesEl = document.getElementById('pb-swatches');
const labelEl    = document.getElementById('pb-label');
const addCartBtn = document.getElementById('pb-add-cart');
const clearBtn   = document.getElementById('pb-clear');
const previewBtn = document.getElementById('pb-preview-btn');
const singlesBtn = document.getElementById('pb-add-singles');
const ppOverlay  = document.getElementById('pp-overlay');
const ppSwatches = document.getElementById('pp-swatches');
const ppSubtitle = document.getElementById('pp-subtitle');
const ppAddBtn   = document.getElementById('pp-add-btn');
const ppKeepBtn  = document.getElementById('pp-keep-btn');
const ppClearBtn = document.getElementById('pp-clear-btn');
const ppClose    = document.getElementById('pp-close');

if (!bar) return;

// ── RENDER ─────────────────────────────────────────────────────
function render() {
  const { size, colors } = state;
  if (!swatchesEl) return;

  swatchesEl.innerHTML = '';
  for (let i = 0; i < size; i++) {
    const c = colors[i];
    const el = document.createElement('div');
    el.className = c ? 'pb-swatch pb-swatch--filled' : 'pb-swatch pb-swatch--empty';
    if (c) {
      el.style.background = c.hex;
      el.title = `${c.code} ${c.name} — click to remove`;
      el.addEventListener('click', () => removeColor(i));
      const x = document.createElement('span');
      x.className = 'pb-swatch-x';
      x.setAttribute('aria-label', 'Remove ' + c.name);
      x.textContent = '×';
      x.addEventListener('click', e => { e.stopPropagation(); removeColor(i); });
      el.appendChild(x);
    } else {
      el.textContent = '+';
      el.addEventListener('click', () => {
        if (window.location.pathname.includes('color-system')) {
          window.dispatchEvent(new CustomEvent('silkhee:palette-add-mode'));
        } else {
          window.location.href = '/pages/color-system?palette=active';
        }
      });
    }
    swatchesEl.appendChild(el);
  }

  if (labelEl) labelEl.textContent = `CUSTOM ${size}-PACK  ·  ${colors.length}/${size} COLORS`;

  const priceEl = document.getElementById('pb-price');
  if (priceEl) priceEl.textContent = PACK_PRICES[size] || '';

  if (addCartBtn) {
    addCartBtn.disabled = colors.length < size;
    addCartBtn.classList.toggle('pb-add-cart--pulse', colors.length === size);
  }

  const ppAddBtnEl = document.getElementById('pp-add-btn');
  if (ppAddBtnEl) {
    ppAddBtnEl.disabled = colors.length < size;
    ppAddBtnEl.classList.toggle('ready', colors.length === size);
    ppAddBtnEl.textContent = `ADD TO CART — ${PACK_PRICES[size] || ''}`;
  }
  const ppSinglesBtnEl = document.getElementById('pp-add-singles');
  if (ppSinglesBtnEl) {
    ppSinglesBtnEl.style.display = (colors.length > 0 && colors.length < size) ? '' : 'none';
  }

  const show = colors.length > 0;
  bar.style.display = show ? 'block' : 'none';
  document.body.style.paddingBottom = show ? BAR_HEIGHT + 'px' : '0px';
  if (show) window.dispatchEvent(new Event('resize'));
}

function addColor(col) {
  if (state.colors.length >= state.size) return false;
  if (state.colors.find(c => c.code === col.code)) return false;
  state.colors.push({ name: col.name, code: col.code, hex: col.hex, handle: col.handle });
  saveState(state);
  render();
  return true;
}

function removeColor(idx) {
  state.colors.splice(idx, 1);
  saveState(state);
  render();
}

function clearPalette() {
  state.colors = [];
  saveState(state);
  render();
}

function setSize(n) {
  state.size = n;
  state.colors = state.colors.slice(0, n);
  saveState(state);
  document.querySelectorAll('.pb-size').forEach(b =>
    b.classList.toggle('active', parseInt(b.dataset.size,10) === n)
  );
  render();
}

// ── CART ───────────────────────────────────────────────────────
async function addPackToCart() {
  const { size, colors } = state;
  if (colors.length < size) return;
  const vid = BUNDLE_VARIANTS[size];
  if (!vid) return;

  const props = {
    _Pack:   `CUSTOM ${size}-PACK`,
    _Colors: colors.map(c => `${c.code} ${c.name}`).join(', '),
  };
  colors.forEach((c, i) => {
    props[`_Hex${i+1}`]  = c.hex;
    props[`_Code${i+1}`] = c.code;
    props[`_Name${i+1}`] = c.name;
  });

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: props }] }),
  });
  if (!res.ok) { console.error('[Palette] Cart error', await res.text()); return; }
  clearPalette();
  if (typeof window.refreshCart === 'function') window.refreshCart();
  if (typeof window.openCart    === 'function') window.openCart();
}

async function addAsIndividualCones() {
  const { colors } = state;
  if (!colors.length) return;
  const items = [];
  for (const c of colors) {
    try {
      const r = await fetch(`/products/${c.handle}.json`);
      const d = await r.json();
      const v = d.product.variants.find(v => !v.sku.includes('*'));
      if (v) items.push({ id: v.id, quantity: 1 });
    } catch(_) {}
  }
  if (!items.length) return;
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items }),
  });
  if (!res.ok) return;
  clearPalette();
  if (typeof window.refreshCart === 'function') window.refreshCart();
  if (typeof window.openCart    === 'function') window.openCart();
}

// ── PREVIEW MODAL ──────────────────────────────────────────────
function openPreview() {
  if (!ppOverlay) return;
  const { size, colors } = state;
  if (ppSubtitle) ppSubtitle.textContent = `CUSTOM ${size}-PACK · ${colors.length}/${size} COLORS`;
  if (ppAddBtn) ppAddBtn.textContent = `ADD TO CART — ${PACK_PRICES[size] || ''}`;
  renderPreviewSwatches();
  ppOverlay.style.display = 'flex';
  previewOpenedAt = Date.now();
  document.body.style.overflow = 'hidden';
}

function renderPreviewSwatches() {
  if (!ppSwatches) return;
  const { size, colors } = state;
  ppSwatches.innerHTML = '';
  for (let i = 0; i < size; i++) {
    const c   = colors[i];
    const div = document.createElement('div');
    div.className   = c ? 'pp-swatch' : 'pp-swatch pp-swatch--empty';
    div.draggable   = !!c;
    div.dataset.idx = i;

    if (c) {
      div.style.background = c.hex;
      const lbl  = document.createElement('div');
      lbl.className = 'pp-swatch-label';
      const name = document.createElement('span');
      name.className   = 'pp-swatch-name';
      name.textContent = c.name.toUpperCase();
      const code = document.createElement('span');
      code.className   = 'pp-swatch-code';
      code.textContent = c.code;
      lbl.appendChild(name);
      lbl.appendChild(code);
      div.appendChild(lbl);

      const ppX = document.createElement('button');
      ppX.className = 'pp-swatch-remove';
      ppX.setAttribute('aria-label', 'Remove ' + c.name);
      ppX.setAttribute('type', 'button');
      ppX.textContent = '×';
      ppX.addEventListener('click', e => {
        e.stopPropagation();
        e.preventDefault();
        removeColor(i);
        renderPreviewSwatches();
        const subtitle = document.getElementById('pp-subtitle');
        if (subtitle) subtitle.textContent = `CUSTOM ${state.size}-PACK · ${state.colors.length}/${state.size} COLORS`;
      });
      div.appendChild(ppX);

      div.addEventListener('dragstart', e => {
        e.dataTransfer.setData('text/plain', String(i));
        setTimeout(() => { div.classList.add('dragging'); }, 0);
      });
      div.addEventListener('dragend', () => {
        div.classList.remove('dragging');
        ppSwatches.querySelectorAll('.drag-over').forEach(el => el.classList.remove('drag-over'));
      });

      // Hover tooltip (dedicated pp-tooltip)
      div.addEventListener('mouseenter', () => {
        const tip = document.getElementById('pp-tooltip');
        if (!tip) return;
        document.getElementById('ppt-swatch').style.background = c.hex || '#ccc';
        document.getElementById('ppt-code').textContent = c.code || '';
        document.getElementById('ppt-name').textContent = (c.name || '').toUpperCase();
        document.getElementById('ppt-hex').textContent = c.hex || '';
        document.getElementById('ppt-hvst').textContent = `HUE · ${c.hue || '—'}   VAL · ${c.val || '—'}   SAT · ${c.sat || '—'}`;
        const rect = div.getBoundingClientRect();
        let tx = rect.left + rect.width / 2 - 80;
        let ty = rect.top - 140;
        if (ty < 8) ty = rect.bottom + 8;
        if (tx + 180 > window.innerWidth) tx = window.innerWidth - 188;
        if (tx < 8) tx = 8;
        tip.style.left = tx + 'px';
        tip.style.top  = ty + 'px';
        tip.style.display = 'block';
      });
      div.addEventListener('mouseleave', () => {
        const tip = document.getElementById('pp-tooltip');
        if (tip) tip.style.display = 'none';
      });
    } else {
      const add = document.createElement('div');
      add.className = 'pp-swatch-add';
      add.innerHTML = '<span>+</span><small>ADD MORE</small>';
      div.appendChild(add);
      const emptyStrip = document.createElement('div');
      emptyStrip.className = 'pp-swatch-label';
      div.appendChild(emptyStrip);
      div.addEventListener('click', () => {
        if (Date.now() - previewOpenedAt < 300) return;
        closePreview();
      });
    }

    div.addEventListener('dragover', e => {
      e.preventDefault();
      if (!div.classList.contains('dragging')) div.classList.add('drag-over');
    });
    div.addEventListener('dragleave', () => div.classList.remove('drag-over'));
    div.addEventListener('drop', e => {
      e.preventDefault();
      div.classList.remove('drag-over');
      const from = parseInt(e.dataTransfer.getData('text/plain'), 10);
      const to   = i;
      if (from === to || isNaN(from)) return;
      const arr = [...state.colors];
      if (!arr[from] || !arr[to]) return;
      [arr[from], arr[to]] = [arr[to], arr[from]];
      state.colors = arr;
      saveState(state);
      renderPreviewSwatches();
    });

    ppSwatches.appendChild(div);
  }
}

function closePreview() {
  if (!ppOverlay) return;
  ppOverlay.style.display = 'none';
  document.body.style.overflow = '';
}

// ── BINDINGS ───────────────────────────────────────────────────
document.querySelectorAll('.pb-size').forEach(btn =>
  btn.addEventListener('click', () => setSize(parseInt(btn.dataset.size, 10)))
);
addCartBtn?.addEventListener('click', addPackToCart);
clearBtn?.addEventListener('click', clearPalette);
if (previewBtn) {
  previewBtn.replaceWith(previewBtn.cloneNode(true));
  const freshBtn = document.getElementById('pb-preview-btn');
  freshBtn?.addEventListener('click', e => {
    e.stopPropagation();
    setTimeout(openPreview, 0);
  });
}
singlesBtn?.addEventListener('click', addAsIndividualCones);
ppClose?.addEventListener('click', closePreview);
ppKeepBtn?.addEventListener('click', closePreview);
ppClearBtn?.addEventListener('click', () => { clearPalette(); closePreview(); });
ppAddBtn?.addEventListener('click', async () => { await addPackToCart(); closePreview(); });
document.getElementById('pp-add-singles')?.addEventListener('click', async () => { await addAsIndividualCones(); closePreview(); });
ppOverlay?.addEventListener('click', e => { if (e.target === ppOverlay) closePreview(); });

// ── PUBLIC API ──────────────────────────────────────────────────
window.silkheeAddToPalette = function(col) {
  // P1: OOS gate — refuse OOS colors at every palette add entry point.
  // Live inventory truth: window.SILKhee.stock[sku] > 0.
  // Fall back to col.in_stock !== false when the map hasn't loaded yet.
  if (col) {
    const sku = (col.code || '') + '-40WT-5000YCONE';
    const stockMap = (window.SILKhee && window.SILKhee.stock) || {};
    const qty = stockMap[sku];
    const isOOS = (typeof qty === 'number') ? qty <= 0 : (col.in_stock === false);
    if (isOOS) {
      // Delegate to the wall's request-modal flow if present; otherwise no-op
      if (typeof window.openRequestModal === 'function') window.openRequestModal(col);
      return;
    }
  }
  const ok = addColor(col);
  if (!ok && state.colors.length >= state.size) {
    bar?.classList.add('pb-flash');
    setTimeout(() => bar?.classList.remove('pb-flash'), 600);
  }
};
window.silkheeReopenPalette   = render;
window.silkheeGetPaletteState = () => ({ ...state });

render();
})();
